export const MuiSkeletonOverrides = {
  defaultProps: {
    // Sets the default animation to "wave"
    animation: 'wave',
  },
};
